/*
 * @Author: RYL
 * @Description: 
 * @Date: 2020-12-17 09:35:51
 * @LastEditTime: 2020-12-17 09:37:30
 */
import http from '@/axios/http'

export function getHistoryData(data) {
  return http({
    url: '/api2/gaterData/list',
    method: 'post',
    data,
  })
}
export function getHistoryDataAll(data) {
  return http({
    url: '/api2/gaterData/listall',
    method: 'post',
    data,
  })
}
